import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.some";
var whiteList = ['https://giftaid.comicrelief.com', 'https://donation.comicrelief.com', 'https://www.comicrelief.com', 'https://www.sportrelief.com', 'https://app.beapplied.com/org/comic-relief'];

var whiteListed = function whiteListed(url) {
  if (url !== undefined && url !== null && whiteList.some(function (v) {
    return url.indexOf(v) >= 0;
  })) {
    return true;
  }

  return false;
};

export default whiteListed;